import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { Connection } from "../../../shared/types";

interface ConnectionListResponse {
  data: Connection[];
}

export function useConnections(brandId: string | undefined) {
  return useQuery({
    queryKey: ["connections", brandId],
    queryFn: () => api.get<ConnectionListResponse>(`/api/connections?brand_id=${brandId}`),
    enabled: !!brandId,
  });
}

export function useDisconnectLinkedIn(brandId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.delete<{ data: { success: boolean } }>(`/api/connections/linkedin?brand_id=${brandId}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["connections", brandId] });
    },
  });
}

export function connectLinkedIn(brandId: string) {
  window.location.href = `/api/connections/linkedin/authorize?brand_id=${brandId}`;
}
